import { useEffect } from 'react';
import {
    Create,
    SimpleForm,
    TextInput,
    SelectInput,
    ReferenceInput,
    AutocompleteInput,
    FormDataConsumer,
    required,
} from 'react-admin';
import { useWatch, useFormContext } from 'react-hook-form';
import { CUSTOM_FIELD_TYPES_CHOICES } from '../../../../config/api';
import { OptionsChipInput } from '../common';

const toSlug = (str) =>
    str
        .toLowerCase()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '') 
        .replace(/[^a-z0-9\s-]/g, '')   
        .trim()
        .replace(/\s+/g, '-');           

const AutoSlug = () => {
    const name = useWatch({ name: 'name' });
    const { setValue } = useFormContext();
    useEffect(() => {
        setValue('slug', toSlug(name || ''));
    }, [name, setValue]);
    return null;
};

const CustomFieldCreate = () => (
    <Create redirect="show">
        <SimpleForm>
            <AutoSlug />
            <ReferenceInput
                source="client_id"
                reference="clients"
                label="Cliente"
                sort={{ field: 'name', order: 'ASC' }}
                perPage={1000}
            >
                <AutocompleteInput
                    optionText="name"
                    filterToQuery={searchText => ({ name: searchText })}
                    validate={[required()]}
                />
            </ReferenceInput>
            <TextInput source="name" validate={[required()]} />
            <TextInput source="slug" validate={[required()]} />
            <SelectInput source="type" choices={CUSTOM_FIELD_TYPES_CHOICES} validate={[required()]} />
            <FormDataConsumer>
                {({ formData }) => formData.type === 'select' && <OptionsChipInput />}
            </FormDataConsumer>
        </SimpleForm>
    </Create>
);

export default CustomFieldCreate;
